import styles from "./InfoPage.module.scss"; // Імпортуємо SCSS файл для стилів
import Nav from "@/components/Header/Nav/Nav";
import Footer from "@/components/Footer/Footer";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const AGB = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Скролимо в верх сторінки
  }, []);

  return (
    <div>
      <Helmet>
        <title>
          Versandbedingungen – HIXA – DSG Getriebe Reparatur & Wartung
        </title>
        <meta name="description" content="Versandbedingungen und Zahlungsmethoden bei HIXA GmbH – Lieferzeiten, Versandkosten und Zahlungsoptionen." />
      </Helmet>

      <Nav />

      {/* Заголовок сторінки */}
      <h2 className={`sectionContainer ${styles.title}`}>Versandbedingungen</h2>

      <div className="container sectionContainer sectionContainerWhite">
        {/* Перша секція */}
        <h2 className={styles.infoPageHeader}>1. Versandgebiete</h2>
        <p className={styles.infoPageText}>
          Wir liefern generalüberholte Mechatronikeinheiten, Steuergeräte,
          Sensoren und weitere Ersatzteile für Automatikgetriebe in alle
          Mitgliedstaaten der Europäischen Union. Zu unseren regelmäßigen
          Versandzielen gehören Deutschland, Österreich, Frankreich, Italien,
          Spanien, Polen, Tschechien, die Niederlande, Belgien, Skandinavien und
          viele weitere EU-Länder.
        </p>
        <p className={styles.infoPageText}>
          Sollten Sie eine Lieferung außerhalb der EU wünschen, kontaktieren Sie
          uns bitte im Voraus, um die Versandoptionen individuell abzuklären.
        </p>

        {/* Друга секція */}
        <h2 className={styles.infoPageHeader}>
          2. Bearbeitungszeit und Versanddauer
        </h2>
        <p className={styles.infoPageText}>
          Ihre Bestellung wird in der Regel innerhalb von 24 Stunden nach
          Zahlungseingang versendet.
        </p>
        <ul className={styles.infoPageList}>
          <li className={styles.infoPageListItem}>
            <b>Innerhalb Deutschlands</b> beträgt die Lieferzeit ca.{" "}
            <b>1–3 Werktage</b>.
          </li>
          <li className={styles.infoPageListItem}>
            <b>Innerhalb der EU</b> erfolgt die Zustellung üblicherweise
            innerhalb von <b>3–7 Werktagen</b>, abhängig vom Zielland und dem
            gewählten Versanddienstleister.
          </li>
        </ul>
        <p className={styles.infoPageText}>
          Bei Bestellungen mit technischer Vorabklärung oder individuellem
          Rücksprachebedarf (z. B. bei Reparaturaustausch) kann sich der Versand
          um kurze Zeit verzögern.
        </p>

        {/* Третя секція */}
        <h2 className={styles.infoPageHeader}>
          3. Versandarten und Dienstleister
        </h2>
        <p className={styles.infoPageText}>
          Wir arbeiten mit zuverlässigen Logistikpartnern wie:
        </p>
        <ul className={styles.infoPageList}>
          <li className={styles.infoPageListItem}>
            <b>DHL Paket International</b>
          </li>
          <li className={styles.infoPageListItem}>
            <b>DPD</b>
          </li>
          <li className={styles.infoPageListItem}>
            <b>UPS</b> (Express auf Wunsch)
          </li>
        </ul>
        <p className={styles.infoPageText}>
          Für schwere oder besonders empfindliche Komponenten (z. B. komplette
          Getriebeeinheiten oder große Mechatroniksysteme) bieten wir zusätzlich
          den Palettenversand per Spedition an. Die Kosten und Lieferzeiten
          hierfür stimmen wir individuell mit Ihnen ab.
        </p>

        {/* Четверта секція */}
        <h2 className={styles.infoPageHeader}>4. Versandkosten</h2>
        <p className={styles.infoPageText}>
          Die Versandkosten richten sich nach Gewicht, Paketgröße und
          Lieferadresse. Standardmäßig gilt:
        </p>
        <ul className={styles.infoPageList}>
          <li className={styles.infoPageListItem}>
            Für Lieferungen innerhalb Deutschlands fallen pauschal{" "}
            <b>Versandkosten ab 7,90 €</b> an.
          </li>
          <li className={styles.infoPageListItem}>
            Für Sendungen ins EU-Ausland berechnen wir{" "}
            <b>Versandkosten ab 14,90 €</b>.
          </li>
        </ul>
        <p className={styles.infoPageText}>
          Bei besonders großen oder schweren Artikeln (z. B. bei
          Palettenversand) teilen wir Ihnen die Versandkosten nach
          Bestelleingang oder Anfrage mit.
        </p>

        <p className={styles.infoPageText}>
          <b>Tipp:</b> Ab einem bestimmten Bestellwert ist der Versand innerhalb
          Deutschlands oder der EU kostenfrei – Details sehen Sie im Checkout.
        </p>

        {/* П’ята секція */}
        <h2 className={styles.infoPageHeader}>
          5. Expressversand & Wunschzustellung
        </h2>
        <p className={styles.infoPageText}>
          Auf Wunsch bieten wir <b>Expressversand</b> an (z. B. DHL Express oder
          UPS Express Saver), mit garantierter Lieferung innerhalb von{" "}
          <b>1–2 Werktagen EU-weit</b>.
        </p>
        <p className={styles.infoPageText}>
          Bitte kontaktieren Sie uns vorab, wenn Sie eine Expresszustellung
          benötigen.
        </p>
        <p className={styles.infoPageText}>
          Wir berücksichtigen außerdem Wunschtermine und Zustellzeiten –
          sprechen Sie uns einfach an.
        </p>

        {/* Шоста секція */}
        <h2 className={styles.infoPageHeader}>
          6. Verpackung & Transportsicherheit
        </h2>
        <p className={styles.infoPageText}>
          Alle Artikel werden <b>fachgerecht, stoßsicher und ölabweisend</b>{" "}
          verpackt. Unsere Spezialverpackungen garantieren größtmöglichen Schutz
          vor Transportschäden – gerade bei sensiblen Bauteilen wie
          Mechatroniken oder Getriebesteuergeräten.
        </p>
        <p className={styles.infoPageText}>
          Jede Sendung wird mit einer <b>Trackingnummer</b> versehen, die Sie
          automatisch per E-Mail erhalten.
        </p>

        {/* Сьома секція */}
        <h2 className={styles.infoPageHeader}>7. Versicherung</h2>
        <p className={styles.infoPageText}>
          Unsere Pakete sind standardmäßig gegen Verlust oder Transportschäden
          bis zu einem bestimmten Warenwert versichert.
        </p>
        <p className={styles.infoPageText}>
          Bei höherwertigen Produkten oder Palettenversand kann eine zusätzliche
          Transportversicherung abgeschlossen werden. Bitte sprechen Sie uns bei
          Bedarf darauf an.
        </p>

        {/* Восьма секція */}
        <h2 className={styles.infoPageHeader}>8. Altteilrückgabe</h2>
        <p className={styles.infoPageText}>
          Für Produkte mit Altteilpfand legen wir Ihrer Lieferung ein
          Rücksendeformular und Informationen zum Ablauf bei.
        </p>
        <p className={styles.infoPageText}>
          Bitte senden Sie das ausgebaute Altteil innerhalb von <b>14 Tagen</b>{" "}
          nach Erhalt der Ware an uns zurück, um die Rückerstattung des
          Pfandbetrags zu erhalten.
        </p>

        <p className={styles.infoPageText}>
          <b>Rücksendeadresse:</b>
        </p>
        <p className={styles.infoPageText}>
          HIXA GmbH
          <br />
          Neukirchstraße 74
          <br />
          13089 Berlin
          <br />
          Deutschland
        </p>

        <p className={styles.infoPageText}>
          Die Kosten für Rücksendungen aus Deutschland übernehmen wir im Rahmen
          der Pfandrückgabe oder bei Reklamationen. Rücksendekosten aus dem
          EU-Ausland trägt der Kunde, sofern nichts anderes vereinbart wurde.
        </p>

        {/* Новий пункт 9 */}
        <h2 className={styles.infoPageHeader}>9. Zahlungsbedingungen</h2>
        <p className={styles.infoPageText}>
          Wir bieten Ihnen sichere und bequeme Zahlungsmöglichkeiten über
          unseren Partner Stripe an. Folgende Zahlungsmethoden stehen Ihnen
          aktuell zur Verfügung:
          <br />
          • Kreditkarten (Visa, Mastercard, American Express)
          <br />
          • Debitkarten
          <br />
          • SEPA-Lastschrift (Bankeinzug)
          <br />• Apple Pay und Google Pay
        </p>

        <p className={styles.infoPageText}>
          Alle Zahlungen werden über eine SSL-verschlüsselte Verbindung
          abgewickelt. Ihre Zahlungsdaten werden ausschließlich über Stripe
          verarbeitet und nicht auf unseren Servern gespeichert.
        </p>

        <p className={styles.infoPageText}>
          <strong>Zahlungsablauf:</strong>
          <br />
          • Die Bezahlung erfolgt direkt während des Bestellvorgangs im
          Stripe-Checkout.
          <br />
          • Ihre Bestellung wird nach erfolgreichem Zahlungseingang bearbeitet
          und versendet.
          <br />• Bei SEPA-Lastschrift kann es je nach Bank 1–2 Tage dauern, bis
          die Zahlung verbucht ist.
        </p>
      </div>

      <Footer />
    </div>
  );
};

export default AGB;
